export const SERVER_URL = process.env.VUE_APP_SERVER_URL!;
export const APP_NAME = process.env.VUE_APP_NAME!;
export const BASE_API_URL = 'https://api.painface.net';
export const TEST_SERVER_URL = `${BASE_API_URL}/test`;
export const PROD_SERVER_URL = `${BASE_API_URL}/production`;
export const LOGIN_COOKIE = 'mpfLogin';
export const MPF_ABOUT_URL = 'https://pain1.godaddysites.com/about-1';
